import styled from 'styled-components';

export const StyledButtons = styled.div`
  bottom: 67px;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 60px;
  z-index: 1000;

  & > *:not(:last-child) {
    margin-bottom: 1em;
  }
  @media all and (max-width: 1200px) {
    & > *:not(:last-child) {
      margin-bottom: 9px;
    }
    left: 20px;
    bottom: 20px;
    right: auto;
  }
`;
